export const versionStringToUniqueNumber = str => {
  const parts = str.split('.')
  // eslint-disable-next-line
  const multipliers = [1000000, 10000, 100, 1]

  let total = 0

  parts.forEach((part, index) => {
    total += Number(part) * multipliers[index]
  })

  return total
}
